import {
    ACTION_GET_LIST_REPORTS,
    ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS,
    ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT,
    ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT,
    ACTION_CONFIRM_MONETIZATIONS,
    ACTION_GET_START_MONETIZATIONS,
    ACTION_EMAIL_SEND_MONETIZATION,
    ACTION_POST_HISTORIC_MONETIZATION,
    ACTION_GET_LIST_CONFIRM_MONETIZATION,
    ACTION_GET_MONETIZATION_REPORT_JOB_STATUS,
    ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS,
    ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS,
    SET_LIST_REPORTS,
    SET_LIST_MONETIZATION,
    SET_CONFIRM_MONETIZATION,
    SET_START_LIST_MONETIZATION,
    SET_EMAIL_SEND_MONETIZATION,
    SET_LIST_CONFIRM_MONETIZATION,
    SET_JOB_STATUS
} from "@/views/reports/store/types/types.js";

import { reportsService } from "../../../services";
import i18n from '@/plugins/i18n';

const actions = {

    [ACTION_GET_LIST_REPORTS]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListReports(idGroup, companyId, userId)
                    .then(async resp => {
                        let reports = resp.data.payload;
                        commit(SET_LIST_REPORTS, reports);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_START_MONETIZATIONS]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListStartMonetizations(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_START_LIST_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_EMAIL_SEND_MONETIZATION]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getEmailSend(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_EMAIL_SEND_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_DOWLOADER_OR_SEND_EMAIL_MONETIZATIONS]: ({ state, commit }, isDowloader) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.generateMonetizationReport(idGroup, companyId, userId, isDowloader)
                    .then(async resp => {
                        commit(SET_LIST_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(resp => {
                        // El interceptor rechaza 202 como error — lo capturamos aquí
                        if (resp.status === 202 && resp.data?.payload?.jobId) {
                            resolve({
                                status: 202,
                                jobId: resp.data.payload.jobId,
                                message: resp.data.payload.message || 'Procesando...'
                            });
                        } else {
                            reject(resp);
                        }
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_LIST_CONFIRM_MONETIZATION]: ({ state, commit } ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.getListConfirmMonetizations(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_LIST_CONFIRM_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_CONFIRM_MONETIZATIONS]: ({ state, commit }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.postConfirmMonetizations(idGroup, companyId, userId, data)
                    .then(async resp => {
                        commit(SET_CONFIRM_MONETIZATION, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(resp => {
                        // El interceptor rechaza 202 como error — lo capturamos aquí
                        if (resp.status === 202 && resp.data?.payload?.jobId) {
                            resolve({
                                status: 202,
                                jobId: resp.data.payload.jobId,
                                message: resp.data.payload.message || 'Procesando...'
                            });
                        } else {
                            reject(resp);
                        }
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_HISTORIC_MONETIZATION]: ({ state }, data ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                reportsService.postHistoricMonetization(idGroup, companyId, userId, data)
                    .then(async resp => {
                        resolve(resp);
                    })
                    .catch(resp => {
                        // El interceptor rechaza 202 como error — lo capturamos aquí
                        if (resp.status === 202 && resp.data?.payload?.jobId) {
                            resolve({
                                status: 202,
                                jobId: resp.data.payload.jobId,
                                message: resp.data.payload.message || 'Procesando...'
                            });
                        } else {
                            reject(resp);
                        }
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
    
    [ACTION_POST_HISTORIC_ASSIGNMENT_DOWNLOAD_REPORT]: ({ state }, payload ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");

                const report = payload.assignTypeStar == "1" ? 
                reportsService.postHistoricAssignmentDownloadReportValue(idGroup, companyId, userId, payload.data) : 
                reportsService.postHistoricAssignmentDownloadReportZen(idGroup, companyId, userId, payload.data);
                
                report.then(async resp => {
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_HISTORIC_ASSIGNMENT_SEND_REPORT]: ({ state }, payload ) => {

        return new Promise((resolve, reject) => {
            try {
                state.loading = true;
                
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");

                const report = payload.assignTypeStar == "1" ? 
                reportsService.postHistoricAssignmentSendReportValue(idGroup, companyId, userId, payload.data) :
                reportsService.postHistoricAssignmentSendReportZen(idGroup, companyId, userId, payload.data);
                
                report.then(async resp => {
                        resolve(resp);
                    })
                    .catch(resp => {
                        if (resp.status === 202) {
                            resolve(resp);
                        } else {
                            reject(resp);
                        }
                    })
                    .finally(() => {
                        state.loading = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    // Acciones de job status para polling
    [ACTION_GET_MONETIZATION_REPORT_JOB_STATUS]: ({ commit }, jobId) => {
        return new Promise((resolve, reject) => {
            try {
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                
                reportsService.getMonetizationReportJobStatus(idGroup, companyId, userId, jobId)
                    .then(resp => {
                        commit(SET_JOB_STATUS, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_CONFIRM_MONETIZATION_JOB_STATUS]: ({ commit }, jobId) => {
        return new Promise((resolve, reject) => {
            try {
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                
                reportsService.getConfirmMonetizationJobStatus(idGroup, companyId, userId, jobId)
                    .then(resp => {
                        commit(SET_JOB_STATUS, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_HISTORY_MONETIZATION_JOB_STATUS]: ({ commit }, jobId) => {
        return new Promise((resolve, reject) => {
            try {
                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                
                reportsService.getHistoryMonetizationJobStatus(idGroup, companyId, userId, jobId)
                    .then(resp => {
                        commit(SET_JOB_STATUS, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
}

export default actions